export default __webpack_public_path__ + "static/media/Torus.21ead316.png";